import { zafClient } from './zafClient'
import { VTEX_PROPERTIES } from '@/constants'
import type { VtexOrder } from '@/interfaces'

const MAPPING_KEY = 'conciex:field-mapping'
const MAPPING_LABELS_KEY = 'conciex:field-mapping-labels'

// { [zendeskFieldId]: vtexKey }
export type FieldMapping = Record<string, string>

export interface MappingLabel {
  vtexKey: string
  vtexLabel: string
  zendeskTitle: string
}
// { [zendeskFieldId]: MappingLabel }
export type FieldMappingLabels = Record<string, MappingLabel>

export function saveFieldMapping(mapping: FieldMapping, labels: FieldMappingLabels): void {
  localStorage.setItem(MAPPING_KEY, JSON.stringify(mapping))
  localStorage.setItem(MAPPING_LABELS_KEY, JSON.stringify(labels))
}

export function loadFieldMapping(): FieldMapping {
  try {
    const stored = localStorage.getItem(MAPPING_KEY)
    return stored ? (JSON.parse(stored) as FieldMapping) : {}
  } catch {
    return {}
  }
}

export function loadFieldMappingLabels(): FieldMappingLabels {
  try {
    const stored = localStorage.getItem(MAPPING_LABELS_KEY)
    return stored ? (JSON.parse(stored) as FieldMappingLabels) : {}
  } catch {
    return {}
  }
}

export async function applyFieldsToTicket(order: VtexOrder, mapping: FieldMapping): Promise<void> {
  if (!zafClient) {
    console.warn('ZAF client not available — running outside Zendesk')
    return
  }

  const updates: Record<string, string> = {}

  for (const [zendeskFieldId, vtexKey] of Object.entries(mapping)) {
    if (!vtexKey) continue
    const prop = VTEX_PROPERTIES.find(p => p.key === vtexKey)
    if (!prop) continue
    updates[`ticket.customField:custom_field_${zendeskFieldId}`] = prop.getValue(order)
  }

  if (Object.keys(updates).length > 0) {
    await (zafClient.set as (obj: Record<string, unknown>) => Promise<void>)(updates)
  }
}
